import React, { useState, useEffect } from 'react';
import { RiAddLine, RiSubtractLine, RiSearchLine, RiQuestionLine } from 'react-icons/ri';
import { useApiCall } from '../hooks/useApiCall';
import '../styles/FAQ.css';

const FAQ = () => {
  const apiCall = useApiCall();
  const [searchTerm, setSearchTerm] = useState('');
  const [activeCategory, setActiveCategory] = useState('1');
  const [expandedItems, setExpandedItems] = useState({});
  const [categories, setCategories] = useState([]);
  const [faqData, setFaqData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  // Fetch FAQ data on component mount
  useEffect(() => {
    fetchFAQ();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const fetchFAQ = async () => {
    setIsLoading(true);
    try {
      const response = await apiCall('faq/get', 'POST', {}, null, null);
      
      if (response.success) {
        setCategories(response.data.categories || []);
        setFaqData(response.data.items || []);
      } else {
        console.error('FAQ fetch failed:', response.message);
      }
    } catch (error) {
      console.error('Error fetching FAQ:', error);
    } finally {
      setIsLoading(false);
    }
  };

  const toggleExpanded = (id) => {
    setExpandedItems(prev => ({
      ...prev,
      [id]: !prev[id]
    }));
  };

  const filteredFAQs = faqData.filter(item => {
    const matchesCategory = activeCategory === '1' || item.category_id === parseInt(activeCategory);
    const matchesSearch = searchTerm === '' || 
      item.question.toLowerCase().includes(searchTerm.toLowerCase()) ||
      item.answer.toLowerCase().includes(searchTerm.toLowerCase());
    
    return matchesCategory && matchesSearch;
  });

  if (isLoading) {
    return (
      <div className="faq-page">
        <div className="faq-container">
          <div className="faq-loading">
            <div className="loading-spinner"></div>
            <p>Loading FAQ...</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="faq-page">
      <div className="faq-container">
        <div className="faq-header">
          <div className="faq-title-section">
            <RiQuestionLine className="faq-header-icon" />
            <div>
              <h1>Frequently Asked Questions</h1>
              <p>Find answers to common questions about Building Depot Suriname</p>
            </div>
          </div>

          <div className="faq-search">
            <div className="search-wrapper">
              <RiSearchLine className="search-icon" />
              <input
                type="text"
                placeholder="Search FAQs..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                className="search-input"
              />
            </div>
          </div>
        </div>

        <div className="faq-content">
          <div className="faq-categories">
            {categories.map(category => (
              <button
                key={category.id}
                className={`category-btn ${activeCategory === category.id ? 'active' : ''}`}
                onClick={() => setActiveCategory(category.id)}
              >
                {category.name}
              </button>
            ))}
          </div>

          <div className="faq-list">
            {filteredFAQs.length === 0 ? (
              <div className="faq-empty">
                <RiQuestionLine className="empty-icon" />
                <h3>No questions found</h3>
                <p>Try adjusting your search or category filter</p>
              </div>
            ) : (
              filteredFAQs.map(item => (
                <div key={item.id} className="faq-item">
                  <button
                    className="faq-question"
                    onClick={() => toggleExpanded(item.id)}
                  >
                    <span>{item.question}</span>
                    {expandedItems[item.id] ? (
                      <RiSubtractLine className="expand-icon" />
                    ) : (
                      <RiAddLine className="expand-icon" />
                    )}
                  </button>
                  
                  {expandedItems[item.id] && (
                    <div className="faq-answer">
                      <p>{item.answer}</p>
                    </div>
                  )}
                </div>
              ))
            )}
          </div>
        </div>

        <div className="faq-contact">
          <div className="faq-contact-section">
            <h3>Still have questions?</h3>
            <p>Our customer service team is here to help you with any additional questions.</p>
            <div className="faq-contact-options">
              <div className="faq-contact-item">
                <strong>Phone:</strong> +597 546-450
              </div>
              <div className="faq-contact-item">
                <strong>Email:</strong> info@buildingdepotsuriname.com
              </div>
              <div className="faq-contact-item">
                <strong>Hours:</strong> Mon-Sat 08:00 - 19:00
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FAQ;